import { ActorFilterOption, BranchFilterOption, DeliveryPhaseFilterOption, DeliveryStateFilterOption, IFilterOption, PaymentStateFilterOption, StringFilterOption } from "../components/common/filter-bar/types";
import { DeliveryPhase, DeliveryState, PaymentState, Workflow } from "../enums/orders";
import { IQuickFilter, IQuickFilterItemDetails } from "../interfaces/common/quick-filters";
import { BranchType } from "../interfaces/delivery-company/branches";

export const quickFiltersToFilterOptions = (quickFilter: IQuickFilter | null): IFilterOption[] => {
    if (!quickFilter) return [];
    const filters = quickFilter.filters;
    const filterOptions: IFilterOption[] = [];

    for (const [key, values] of Object.entries(filters)) {
        switch (key) {
            case 'delivery_state':
                for (const v of values) {
                    filterOptions.push(new DeliveryStateFilterOption(v.value as DeliveryState, true, true));
                }
                break;
            case 'payment_state':
                for (const v of values) {
                    filterOptions.push(new PaymentStateFilterOption(v.value as PaymentState, true, true));
                }
                break;
            case 'phase':
                for (const v of values) {
                    filterOptions.push(new DeliveryPhaseFilterOption(v.value as DeliveryPhase, true, true));
                }
                break;
            case 'merchant':
                for (const v of values) {
                    filterOptions.push(new ActorFilterOption({
                        actortype: 'merchant',
                        val: {
                            id: v.value,
                            name: v.label,
                            phone_number: ''
                        }
                    }, true, undefined, true));
                }
                break;
            case 'customer':
                for (const v of values) {
                    filterOptions.push(new ActorFilterOption({
                        actortype: 'customer',
                        val: {
                            id: v.value,
                            name: v.label,
                            phone_number: ''
                        }
                    }, true, undefined, true));
                }
                break;
            case 'driver':
                for (const v of values) {
                    filterOptions.push(new ActorFilterOption({
                        actortype: 'driver',
                        val: {
                            id: v.value,
                            name: v.label,
                            phone_number: ''
                        }
                        }, true, undefined, true));
                }
                break;
            case 'workflow':
                for (const v of values) {
                    filterOptions.push(new StringFilterOption('workflow', v.value as Workflow, true, true));
                }
                break;
            case 'district':
                for (const v of values) {
                    filterOptions.push(new StringFilterOption('district', v.value as string, true, true));
                }
                break;
            case 'governorate':
                for (const v of values) {
                    filterOptions.push(new StringFilterOption('governorate', v.value as string, true, true));
                }
                break;
            case 'branch':
                for (const v of values) {
                    filterOptions.push(new BranchFilterOption({id: v.value, name: v.label} as BranchType, true, true ));
                }
                break
            default:
                console.error("Unexpected filter key: ", key)

        }
    }

    return filterOptions;
}

export const filterOptionsToQuickFilter = (filterOptions: IFilterOption[]): Record<string, IQuickFilterItemDetails[]> => {
    const filters = new Map<string, IQuickFilterItemDetails[]>();
    
    filterOptions.forEach((filter) => {
        const { key, value } = filter.toQuery();
        if (filters.has(key)) {
            filters.get(key)?.push({
                value: value,
                label: filter.toLabel()
            });
        } else {
            filters.set(key, [{
                value: value,
                label: filter.toLabel()
            }]);
        }
    });

    return Object.fromEntries(filters) as Record<string, IQuickFilterItemDetails[]>;
}